<script setup>
import { __ } from '@/utils';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useField } from 'vee-validate';

const invoice = [
  { id: 'email', value: __('Email') },
  { id: 'website', value: __('Website') },
  { id: 'mail', value: __('Israel Post') },
];

const showDropDown = ref(false);
const { handleChange, value: selectedInvoice } = useField('selectedInvoice');

const toggleDropDown = () => {
  showDropDown.value = !showDropDown.value;
}

const selectInvoice = (invoiceType) => {
  showDropDown.value = false;
  handleChange(invoiceType.id)
}

handleChange(invoice[0].id);

const handleClickOutside = (event) => {
  const dropdownElement = document.querySelector('.dropdown-invoice');
  if (dropdownElement && !dropdownElement.contains(event.target)) {
    showDropDown.value = false;
  }
}

function getValueId(id) {
  const label = invoice.find(op => op.id === id);
  return label ? label : null;
}

const invoiceLabel = computed(() => getValueId(selectedInvoice.value));

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<template>
  <div class="choice">
    <span class="choice__label">
      {{ __('How to receive the invoice') }}
    </span>

    <div class="dropdown dropdown-invoice" :class="{ 'is-active': showDropDown }">
      <div class="dropdown__head" @click.stop="toggleDropDown">
        <span>
          {{ invoiceLabel.value }}
        </span>
      </div><!-- /.dropdown__head -->

      <div class="dropdown__list" v-if="showDropDown">
        <ul>
          <li v-for="item in invoice" :key="item.id">
            <a href="#" @click.prevent="selectInvoice(item)">
              <span>
                {{ item.value }}
              </span>
            </a>
          </li>
        </ul>
      </div><!-- /.dropdown__list -->
    </div><!-- /.dropdown -->
  </div><!-- /.choice -->
</template>
